// extracted by mini-css-extract-plugin
export var growableInput = "_6o-0";
export var tagContainer = "_6o-2";
export var textInput = "_6o-1";